module.exports = __webpack_public_path__ + "static/media/logo_white.6a6674b5.png";